import { lazyLoad } from 'components/ui/LazyLoad'

export const docsRoutes = {
  docs: {
    path: '/docs',
    component: lazyLoad(() => import('views/docs/Main')),

    views: {
      refundPolicy: {
        path: '/docs/refund-policy',
        component: lazyLoad(() => import('views/docs/RefundPolicy/RefundPolicy')),
        meta: {
          title: 'Refund Policy - gameskinx',
          description: 'Refund Policy of ARWAESDIGITAL LTD the operator of gameskinx.com.',
        },
      },
      cancellationPolicy: {
        path: '/docs/cancellation-policy',
        component: lazyLoad(() => import('views/docs/CancellationPolicy/CancellationPolicy')),
        meta: {
          title: 'Cancellation Policy - gameskinx',
          description: 'Cancellation Policy of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
        },
      },
      cookiePolicy: {
        path: '/docs/cookie-policy',
        component: lazyLoad(() => import('views/docs/CookiePolicy/CookiePolicy')),
        meta: {
          title: 'Cookie Policy - gameskinx',
          description: 'Cookie Policy of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
        },
      },
      privacyPolicy: {
        path: '/docs/privacy-policy',
        component: lazyLoad(() => import('views/docs/PrivacyPolicy')),
        meta: {
          title: 'Privacy Policy - gameskinx',
          description: 'Privacy Policy of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
        },
      },
      termsOfUse: {
        path: '/docs/terms-of-use',
        component: lazyLoad(() => import('views/docs/TermsOfUse')),
        meta: {
          title: 'Terms & Conditions - gameskinx',
          description: 'Terms & Conditions of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
        },
      },
      membershipAgreement: {
        path: '/docs/membership-agreement',
        component: lazyLoad(() => import('views/docs/MembershipAgreement')),
        meta: {
          title: 'Membership Agreement - gameskinx',
          description: 'Membership Agreement of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
        },
      },
      // imprint: {
      //   path: '/docs/imprint',
      //   component: lazyLoad(() => import('views/docs/Imprint/Imprint')),
      //   meta: {
      //     title: 'Imprint - gameskinx',
      //     description: 'Imprint of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
      //   },
      // },
      // licenseAgreement: {
      //   path: '/docs/content-license-agreement',
      //   component: lazyLoad(() => import('views/docs/LicenseAgreement')),
      //   meta: {
      //     title: 'Content License Agreement - gameskinx',
      //     description:
      //       'Content License Agreement of ARWAESDIGITAL LTD the operator of gameskinx.com.',
      //   },
      // },
      // editorialAgreement: {
      //   path: '/docs/editorial-content-supply-agreement',
      //   component: lazyLoad(() => import('views/docs/EditorialAgreement')),
      //   meta: {
      //     title: 'Editorial Content Supply Agreement - gameskinx',
      //     description:
      //       'Editorial Content Supply Agreement of ARWAESDIGITAL LTD, the operator of gameskinx.com.',
      //   },
      // },
    },
  },
} as const
